import { ReactNode } from 'react';

interface CenteredMessageProps {
  children: ReactNode;
  className?: string;
}

/**
 * A centered full-screen container for displaying messages
 */
export function CenteredMessage({ children, className = '' }: CenteredMessageProps) {
  return (
    <div className={`${className}`.trim()}>
      {children}
    </div>
  );
}